export default function anonymous(props
) {
var out='<div class="'+(props.styles.logoWrapper)+'"></div>';return out;
}